var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-message-editor-with-media-input',{attrs:{"setup":{
    'func': _vm.setMessageHandler,
    'args': Object.assign({}, {'model': _vm.$props,
      'key': 'message',
      'prefix': ((_vm.snakeCase(_vm.ActionTypes.NotifyGroup)) + "_action_"),
      'validation': 'required',
      'hasMedia': true,
      'availableButtonsTypes': _vm.availableButtonsTypes,
      'buttonsHelpView': _vm.buttonsHelpView,
      'placeholders': _vm.placeholders,
      'targetToUpload': {
        'target': 'target',
        'target_id': _vm.board,
      },
      'settingsStructure': {
        'pin': false,
        'disable_link_preview': false,
        'disable_notify': false,
        'remove_previous': false,
        'protect_content': false,
        'remove_after': 0,
        'topics': []
      },
      'customMediaTypes': _vm.customMediaTypes,
      'options': { topics: null }},
      _vm.editorTopics ? _vm.editorTopics : undefined)
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }